const IconAdd = ({ className }) => {
    return (
        <svg
            width='35'
            height='36'
            viewBox='0 0 35 36'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.4997 6.33337C18.3051 6.33337 18.958 6.98629 18.958 7.79171V16.5417H27.708C28.5134 16.5417 29.1663 17.1946 29.1663 18C29.1663 18.8055 28.5134 19.4584 27.708 19.4584H18.958V28.2084C18.958 29.0138 18.3051 29.6667 17.4997 29.6667C16.6943 29.6667 16.0413 29.0138 16.0413 28.2084V19.4584H7.29134C6.48593 19.4584 5.83301 18.8055 5.83301 18C5.83301 17.1946 6.48593 16.5417 7.29134 16.5417H16.0413V7.79171C16.0413 6.98629 16.6943 6.33337 17.4997 6.33337Z'
            />
        </svg>
    );
};

export default IconAdd;
